import { GraphQLIssueDAOFactory } from "../../../../lib/issue/dao/graphql/GraphQLIssueDAOFactory";
import { Issue } from "../../../../models";
import { ListResponse } from "../../../../lib/util/data/list/ListResponse";
import { REFETCH_POLLING_TIMES_MS } from "../../PropertyDashboard";
import { useQuery } from "react-query";

const issueDAO = GraphQLIssueDAOFactory.getInstance();

export const useIssuesByPropertyId = (propertyId: string) => {
    return useQuery(
        ['issues', 'property', propertyId],
        async () => {
            let allIssues: Array<Issue> = [];
            let nextToken = undefined;
            do {
                const response: ListResponse<Issue> = await issueDAO.getIssuesByPropertyId(propertyId, nextToken);
                allIssues = [...allIssues, ...response.items];
                nextToken = response.nextToken;
            } while (nextToken);
            return allIssues;
        },
        {
            enabled: !!propertyId,
            refetchInterval: REFETCH_POLLING_TIMES_MS,
            refetchIntervalInBackground: true,
            keepPreviousData: true
        }
    );
};
